export default __webpack_public_path__ + "static/media/product_1_friim_1.7bd037dd.png";